
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {rulesApi} from "@/api/rules";
    import {IPage} from "@/js/page";
    @Component({
        name: 'SelectRules',
    })
    export default class SelectRules extends Vue {
        @Prop()
        private value !: any;     //传入的规程ID
        @Prop()
        private rowIndex !: any;//下标 可以不传
        @Prop()
        private rulesType !: any; // 0 地方 1国家 2共享 3其它
        @Prop()
        private dataObj !: any; // 编辑时的首次数据
        @Prop()
        private urlType !: any; // 接口类型  1是copy
        listParam: IPage = {
            size: 1000,
            current: 1,
        };
        rulesId = "" ;//当前选中的ID
        rulesList = [] as any;  //备选项
        created() {
            this.rulesId = this.value;
            if(this.urlType == 1){
                if(this.dataObj && this.dataObj.number){
                    this.rulesList = [this.dataObj];
                }
            }else{
                if(this.dataObj && this.dataObj.id){
                    this.rulesList = [this.dataObj];
                }
            }
        }
        remoteMethod(number: string) {
            if(number){
                setTimeout(() => {
                    this.page(number);
                }, 200);
            }else{
                this.rulesList = [];
            }
        }
        page(number: string){
            const params = {
                ...this.listParam,
                number :number,
                type: this.rulesType,
            }
            let api;
            if(this.urlType == 1){
                api = rulesApi.pageCopy(params);
            }else{
                api = rulesApi.list(params)
            }
            api.then(r => {
                if (r.data.result === 0) {
                  if(this.urlType == 1){
                    this.rulesList = r.data.data.records;
                  }else{
                    this.rulesList = r.data.data;
                  }
                }
            })
        }
        changeRules(){
            const data = this.rulesList.find((e:any) => (this.urlType==1?e.number:e.id) == this.rulesId);
            if(data){
                const data2 = this.cloneData(data);
                data2.rowIndex = this.rowIndex;
                this.$emit('onChange', data2);
            }
            if(!this.rulesId){
                this.remoteMethod("");
                this.$emit('onChange', {
                    rowIndex: this.rowIndex,
                    id: "",
                    number: "",
                    name: "",
                });
            }
        }
        cloneData(data: any){
            return JSON.parse(JSON.stringify(data));
        }
        @Watch("value")
        valueChange(val: string) {
            this.rulesId = val;
        }
    }
